module.exports = __webpack_public_path__ + "img/icon.d6d14cd6.png";